import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

export const isSSR = () => typeof window === 'undefined'

export const getUrlQueryParams = () => {
  if (isSSR()) return {}
  const params = new URLSearchParams(window.location.search)
  return Object.fromEntries(params.entries())
}

export const updateHistoryQueryParams = (newUrlQueryParams) => {
  if (isSSR()) return

  const newPath = newUrlQueryParams
    ? `${window.location.pathname}?${newUrlQueryParams}`
    : window.location.pathname

  history.pushState(null, null, newPath)
}

export const trunc = (str, len = 100) => {
  if (typeof str !== 'string') {
    return ''
  }
  if (str.length <= len) {
    return str
  }
  return str.substr(0, len - 1) + '...'
}

export const isEmailValid = (email) => {
  var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
  return emailRegex.test(email)
}

export const parseUrlToSlugAndHref = (url) => {
  const href = url?.match(/^(http|https|mailto|tel):\/\//) ? url : null
  const formattedSlug = url?.match(/^\/.+/) ? url.slice(1) : url
  const slug = href ? null : formattedSlug

  return [slug, href]
}

export const isExternalURL = (url) => {
  const domain = (url) =>
    url?.replace('http://', '')?.replace('https://', '')?.split('/')[0]
  return (
    typeof window !== 'undefined' &&
    domain(window?.location.href) !== domain(url)
  )
}

export const parseQueryString = (query, queryVariable) => {
  const variables = query.split('&')
  for (let i = 0; i < variables.length; i++) {
    let pair = variables[i].split('=')

    if (decodeURIComponent(pair[0]) === queryVariable) {
      return decodeURIComponent(pair[1])
    }
  }
}

export const filterSampleEntries = (entries) => {
  const regex = new RegExp(/^\[CMS Schema Required\]/i)
  if (!entries) return entries
  return entries.filter(({ title }) => title && !title.match(regex))
}

export const richTextToPlainText = (richText) => {
  if (!richText) return ''
  if (richText?.raw) {
    return (
      documentToPlainTextString(JSON.parse(richText?.raw)).slice(0, 200) + '...'
    )
  }
  return documentToPlainTextString(richText).slice(0, 200) + '...'
}

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
